(() => {
  const setImage = (card, src) => {
    const image = card.querySelector('.product-card__media-item:not(.product-card__media-item--second)');
    if (!image || !src) return;

    if (!image.dataset.colorFamilyOriginalSrc) {
      image.dataset.colorFamilyOriginalSrc = image.getAttribute('src') || '';
      image.dataset.colorFamilyOriginalSrcset = image.getAttribute('srcset') || '';
    }

    image.src = src;
    image.removeAttribute('srcset');
  };

  const restoreImage = (card) => {
    const image = card.querySelector('.product-card__media-item:not(.product-card__media-item--second)');
    if (!image || !image.dataset.colorFamilyOriginalSrc) return;

    image.src = image.dataset.colorFamilyOriginalSrc;
    if (image.dataset.colorFamilyOriginalSrcset) image.srcset = image.dataset.colorFamilyOriginalSrcset;
  };

  document.querySelectorAll('.product-card__color-swatches').forEach((swatches) => {
    const card = swatches.closest('.product-card');
    if (!card) return;

    swatches.querySelectorAll('[data-color-family-swatch]').forEach((swatch) => {
      const preview = () => setImage(card, swatch.dataset.imageSrc);
      swatch.addEventListener('mouseenter', preview);
      swatch.addEventListener('focus', preview);
    });

    swatches.addEventListener('mouseleave', () => restoreImage(card));
    swatches.addEventListener('focusout', (event) => {
      if (!swatches.contains(event.relatedTarget)) restoreImage(card);
    });
  });
})();
